export enum EOtevrenyUzavreny {
    OTEVRENY = 'OTEVRENY',
    UZAVRENY = 'UZAVRENY'
}
